export interface NameValue<T> {
  name: string;
  value: T;
}
export interface IDescription {
  Description: string;
}
export interface IName {
  Name: string;
}
export function NameValueIntSorter(a: NameValueInt, b: NameValueInt) {
  return a.name === b.name ? 0 : +(a.name > b.name) || -1;
}
export function NameSorter(a: IName, b: IName) {
  return a.Name === b.Name ? 0 : +(a.Name > b.Name) || -1;
}
export function DescriptionSorter(a: IDescription, b: IDescription) {
  return a.Description === b.Description ? 0 : +(a.Description > b.Description) || -1;
}
export interface NameValueInt extends NameValue<number> {
  name: string;
  value: number;
}
export interface NameValueBool extends NameValue<boolean> {
  name: string;
  value: boolean;
}
export interface NameValueString extends NameValue<string> {
  name: string;
  value: string;
}
export interface NameValueDate extends NameValue<Date> {
  name: string;
  value: Date;
}
export interface NameValueIntParentInt extends NameValue<number> {
  name: string;
  value: number;
  parentValue: number;
}
export interface NameValueIntParentActiveInt extends NameValue<number> {
  name: string;
  value: number;
  parentValue: number;
  isActive: boolean;
}
export interface NameValueIntParentIntFunctionInt extends NameValue<number> {
  name: string;
  value: number;
  parentValue: number;
  functionValue?: number;
}